<div class="select-btn-modal-container">

    <div class="selection-header-container">
        <p class="selection-header">{{header}}</p>
    </div>

    <div class="selection-body">
        
        @if (subHeader) {
            <p class="selection-sub-header">{{subHeader}}</p>
        }
        
        @for (item of selectionItems; track ITEM_ID_PREFIX+item.id) {

            <div [id]="ITEM_ID_PREFIX+item.id" class="select-modal-item" [ngClass]="{'selected-item': item.isSelected}" [hidden]="isItemHidden(item)">
                <span (click)="itemClicked(item)">
                    @if (item.isSelected) {<i class="fa-solid fa-check"></i>}
                    @if (item.iconImg) { <img [src]="item.iconImg" class="selection-item-icon-image" /> }
                    {{item.label}}
                </span>
                @if (isShowDeleteButton) {
                    <span (click)="deleteItem(item)"><i class="fa-solid fa-trash-can"></i></span>
                }
            </div>

        }
        @empty {
            <div class="text-center">
                <span>{{emptyMsg}}</span>
            </div>
        }

    </div>

    <div class="selection-footer-container">

        <app-btn (click)="closeDialog(null)" class="mx-1" padding="6px 24px"><span class="btn-txt">Annulla</span></app-btn>
        @if (isMultipleSelection) {
            <app-btn (click)="closeDialog(getSelectedItems())" padding="6px 24px"><span class="btn-txt">Conferma</span></app-btn>
        }
        @if (isShowDeleteButton && itemsToDelete.length > 0) {
            <app-btn (click)="deleteItems()" padding="6px 24px"><span class="btn-txt">Conferma</span></app-btn>
        }

    </div>

</div>